
<template>
  <div class="site">
     <!-- eslint-disable  -->
      <SiteHead :isNew="false" :isNews="true" :siteName='siteName' :regPage='regPage' :cancalChild = 'cancalChild' :thisScore='thisScore' :numScore='numScore' :isHelpShow='isHelpShow' :isChisShow='isChisShow' :helpPop="isHelp" :knowledgePop="isChis" :isShowScore='isScore' :isPy='isPy' :isLeasing='isLeasing' :goRegPage='goRegPage'></SiteHead>
      <div class="content">
        <div class="view">
          <iframe name="stie" ref="iframe" id="bdIframe" :src="view.src" frameborder="0" hight='auto'></iframe>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="AccountInfo">
        <div class="colsCont">
          <div class="close" @click="AccountInfo=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <!-- <div class="pinyin" :class="{lv:isPingyin}" @click="lePingyin()">拼音转换</div> -->
          <div class="head">
            <div class="uname">账号资料</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其他非法用途（为保证模拟注册过程中的有效评分，请勿使用网站翻译功能）</div>
          </div>
          <div class="cont">
            <div class="name">邮箱信息</div>
            <div class="dv"><div class="dName"><span>电子邮箱地址 </span><span>：</span> </div><div class="span">{{VirtualInfo.email}}</div> </div>
          </div>
          <div class="cont">
            <div class="name">法人及公司资料</div>
            <div class="dv"><div class="dName"><span>法人名称 </span><span>：</span> </div><div class="span">{{VirtualInfo.yourName}}</div> </div>
            <div class="dv"><div class="dName"><span>电话号</span><span>：</span></div><div class="span">+91</div><div class="span ee">996823010</div></div>
            <div class="dv"><div class="dName"><span>备用手机号</span><span>：</span></div><div class="span">+91</div><div class="span ee">981059899</div></div>
            <div class="dv"><div class="dName"><span>法人公司名</span><span>：</span></div><div class="span">{{VirtualInfo.HolderName}}</div> </div>
            <div class="dv"><div class="dName"><span>公司地址</span><span>：</span></div><div class="span">{{VirtualInfo.address1}}{{VirtualInfo.address2}}</div> </div>
            <div class="dv"><div class="dName"><span>城市</span><span>：</span></div><div class="span">{{VirtualInfo.city}}</div> </div>
            <div class="dv"><div class="dName"><span>区域/州</span><span>：</span></div><div class="span">{{VirtualInfo.state}}</div> </div>
            <div class="dv"><div class="dName"><span>邮编</span><span>：</span></div><div class="span">{{VirtualInfo.pinCode}}</div> </div>
            <div class="dv"><div class="dName"><span>GSTIN号码</span><span>：</span></div><div class="span">{{VirtualInfo.GSTIN}}</div> </div>
            <div class="dv"><div class="dName"><span>PAN号码</span><span>：</span></div><div class="span">{{VirtualInfo.PAN}}</div> </div>
          </div>
          <div class="cont">
            <div class="name">银行账户信息</div>
            <div class="dv"><div class="dName"><span>账户持有人</span><span>：</span></div><div class="span">Jhakaas Retail Private Limited</div> </div>
            <div class="dv"><div class="dName"><span>账户类型</span><span>：</span></div><div class="span"></div>储蓄账户</div>
            <div class="dv"><div class="dName"><span>账户号码</span><span>：</span></div><div class="span">{{VirtualInfo.AccountNum}}</div> </div>
            <div class="dv"><div class="dName"><span>IFSC代码</span><span>：</span></div><div class="span">CITI0101111</div></div>
          </div>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="isIds">
        <div class="colsCont">
          <div class="close" @click="isIds=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">法人身份证</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其它非法用途！</div>
          </div>
          <div class="cont">
            <div class="name">身份证正面 <div class="btn" @click="downloadCodeImg(0)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/身份证正面.jpg'" alt="">
            </div>
          </div>
           <div class="cont">
            <div class="name">身份证反面 <div class="btn" @click="downloadCodeImg(1)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/身份证背面.jpg'" alt="">
            </div>
          </div>
        </div>
      </div>
       <div class="colsPop pyPop"  v-drag v-if="isPy">
        <div class="colsCont">
          <div class="close" @click="isPy=false;zwCont='';pingyinCont='';">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">汉字转拼音</div>
          </div>
          <div class="input_wrap">
            <div class="ipt">
              <label >中文</label><input type="text" v-model="zwCont">
            </div>
            <div class="ipt">
              <label >拼音</label> <input type="text" v-model="pingyinCont">
            </div>
          </div>
          <div class="iBtn" @click="goPinyin">一键转换</div>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="businessLicense">
        <div class="colsCont">
          <div class="close" @click="businessLicense=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">营业执照</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其它非法用途！</div>
          </div>
          <div class="cont" >
            <div class="name">营业执照<div class="btn" @click="downloadCodeImg(2)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/营业执照正本.jpg'" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="pop_bg" v-if="reexamination"></div>
      <CommonPop :reexamination='reexamination' :scoreFun ='scoreFun' :textCommonPop='textCommonPop' ></CommonPop>
      <div class="tipsPop" v-if="tips">
      <div class="head">
          提示
          <div class="icon" @click="tips=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="co">
            <img src="../../assets/images/mark.png" alt="">
          </div>
          <div class="cont">
              您将要清空所有注册数据，确认是否继续
          </div>   
          <div class="btnWrap">
              <div class="btn" @click="deleteInfo()">是</div><div class="btnN" @click="tips=false">否</div>
          </div>
      </div>
    </div>
    <div class="pop_bg" v-if="isSelectPop"></div>
    <div class="selectPop" v-if="isSelectPop">
      <div class="title">
        恭喜您，已完成印度站模拟注册 
          <div class="close" @click="isSelectPop=false">
              <img src="../../assets/images/close.svg" >
          </div>
        </div>
      <div class="btn" @click="cancalChild('score')">
        查看填写参考
      </div>
    </div>
      <div class="pop_bg" v-if="isScore"></div>
      <div class="scorePop" v-if="isScore">
          <div class="head">
              <!-- <div class="el">
                  <div class="li avt">
                     <div class="num">{{thisScore}}</div> 
                     <div class="nx">目前得分</div>
                  </div>
                  <div class="li">
                     <div class="num">{{numScore}}</div> 
                     <div class="nx">目前总分</div>
                  </div>
              </div> -->
              <!-- <div class="ps">考核分数只是针对注册中的填写信息对错来衡量，不与实际注册成功与否挂钩！！！</div> -->
              <div class="btnScore" @click="tips=true">重新练习</div>
              <div class="close" @click="closeScore">
                <img src="../../assets/images/close.svg" >
              </div>
          </div>
          <div class="cont">
            <div class="titUl">
              <div class="li">注册信息</div>
              <div class="li fx4">填写内容</div>
              <!-- <div class="li">评分</div> -->
              <div class="li">结果</div>
              <div class="li fx4">填写信息知识点说明</div>
            </div>
            <div class="conList">
               <div class="titUl" v-for="(item,index) in infoScore" :key="index" :class="{avt:item.result==0}">
                <div class="li">{{item.name}}</div>
                <div class="li fx4">{{item.mcont}}</div>
                <!-- <div class="li">{{item.credit}}</div> -->
                <div class="li dP"><img :src="item.result==0?require('../../assets/images/Wrong.png'):require('../../assets/images/correct.png')" alt="">{{item.resultCont}}</div>
                <div class="li fx4">{{item.knowledgePoint}}</div>
              </div>
            </div>
          </div>
      </div>
    
  </div>
</template>
<script>
import SiteHead from '../../components/SiteHead/Index';
import CommonPop from '../../components/CommonPop/Index';
import {vInfo,virtualConfigEntityList,creditRuleEntityList} from '../../assets/js/common_fun';
export default {
  name: "site",
  data: function() {
    return {
      siteName:'印度',
      regPage:[
        '登录账号',
        '注册账号',
        '验证邮箱',
        '公司名称',
        '业务信息',
        '启用两步验证',
        '两步验证号码',
        '完成两步验证',
        '税务信息',
        '商品信息',
        '卖家中心',
        '考核报表'
      ],
      StateArr:["Select State","Maharashtra","GOA","KERALA","LAKSHADWEEP","DADRA & NAGAR HAVELI","HIMACHAL PRADESH","ANDAMAN & NICOBAR ISLANDS","ANDHRA PRADESH",
"UTTAR PRADESH","HARYANA","ASSAM","ODISHA","CHANDIGARH","MADHYA PRADESH","WEST BENGAL","MEGHALAYA","PUDUCHERRY","RAJASTHAN","NAGALAND","SIKKIM","GUJARAT","KARNATAKA",
"MIZORAM","DAMAN & DIU","ARUNACHAL PRADESH","BIHAR","CHHATTISGARH","PUNJAB","JAMMU & KASHMIR","TAMIL NADU","UTTARAKHAND","DELHI","JHARKHAND","MANIPUR",
"TRIPURA","TELANGANA"],
      accountTypeArr:["--Select Your Account Type--","Overdraft Account","Current Account","Savings Account"],
      TaxCodeArr: ["A_GEN_EXEMPT (0%)","A_GEN_JEWELLERY (3%)","A_GEN_MINIMUM (0.25%)","A_GEN_PEAK (28%)","A_GEN_PEAK_CESS12 (28% + 12%)","A_GEN_PEAK_CESS60 (28% + 60%)",
"A_GEN_REDUCED (12%)","A_GEN_STANDARD (18%)","A_GEN_SUPERREDUCED (5%)"],
      numScore:0,
      thisScore:0,
      zwCont:'',
      isLeasing:'',
      pingyinCont:'',
      isPingyin:false,
      isSelectPop:false,
      numScores:null,
      textCommonPop:'',
      infoScore:[],
      reexamination:false,
      isHelpShow:false,
      isScore:false,
      isPy:false,
      isChisShow:false,
      iframeHeight:null,
      isHelp:false,
      isChis:false,
      AccountInfo:false,
      isIds:false,
      VirtualInfo:{
			},
      businessLicense:false,
      iframeWin: {},
      tips:false,
      mPage:'',
      virtualConfigEntityList:[],
      creditRuleEntityList:[],
      view:{
         src:'',
      },
      regInfo:{},
      AmazonRegAccountInfo:{},
      chis:'0',
      help:'0'
    };
  },
 //注册局部组件指令
//注册局部组件指令
  directives: {
      drag: function(el) {
          let dragDiv = el; //获取当前元素
          dragDiv.addEventListener("mousedown", function(e) {
             if(e.target.className=='de' || e.target.className== 'uname'){
              //获取div初始位置对象
              var divRect = dragDiv.getBoundingClientRect();
              //获取鼠标点击的位置
              var downX = e.clientX;
              var downY = e.clientY;
              //开关打开
              var startMove = true;
              //设置样式为移动光标
              dragDiv.style.cursor = "move";
              window.onmousemove = function(e) {
              if (!startMove) {
              return;
              }
              let newLeft = e.clientX - downX + divRect.left;
              let newTop = e.clientY - downY + divRect.top;
              if(newLeft>=0){
                dragDiv.style.left = newLeft + "px";
              }
              if(newTop>=0){
                dragDiv.style.top = newTop + "px";
              }
              return false;
              };
              window.onmouseup = function(e) {
              //结束移动
              startMove = false;
              dragDiv.style.cursor = "default";
              return false;
              };

              e.stopPropagation();
             }
        });
      }
  },
  mounted () {
    /* eslint-disable */
    let oIframe = document.getElementById('bdIframe');
    let regInfoJson={};
      // 在外部vue的window上添加postMessage的监听，并且绑定处理函数handleMessage
      window.addEventListener('message', event => {
            // 根据上面制定的结构来解析iframe内部发回来的数据
          const data = event.data
          console.log(data)
          try { 
            if(data){
              if(data=='deleteInfo'){
                this.deleteInfo('ifemDe')
              }
              if(data=='creditok'){
                if(sessionStorage.getItem('zsMode')!=9){
                   this.isSelectPop=true;
                }
              }
              regInfoJson=this.virtualConfigEntityList.filter(item => item.currentPage==data.mPage)
             if(data.iframeHeight){
               this.isChisShow=false;
               this.isHelpShow=false;
               this.help='0'
               this.chis='0'
                this.getScoreList()
              }
              if(data.mPage){
                this.mPage=data.mPage
              }
              
              if(data.chis==0){
                this.isChisShow=false;
              }
              if(data.help==0){
                  this.isHelpShow=false;
              }
              if(regInfoJson[0].helpBtn==0){
                  this.isHelp=false;
                }else{
                  this.isHelp=true;
                }
              if(regInfoJson[0].knowledgeBtn==0){
                this.isChis=false;
              }else{
                this.isChis=true;
              }
            }
            
        } catch(err) {
        }
          
        });
      this.iframeWin = this.$refs.iframe.contentWindow;
    },
    computed: {
        user() {
          return this.$store.getters.user;
        },
  },
   watch: {
  },
  created(){
    this.VirtualInfo=vInfo()
    this.virtualConfigEntityList=virtualConfigEntityList()
    this.creditRuleEntityList=creditRuleEntityList()
    sessionStorage.regMarketArr=JSON.stringify(this.creditRuleEntityList)
    // sessionStorage.multilingual='0'
    sessionStorage.vInfo = JSON.stringify(this.VirtualInfo)
    this.getSite()
    // this.getVirtualInfo()
    this.getBeforeAmazonRegAccountInfo()
  },
  methods: {
      goRegPage(e){
          switch (e) {
            case 0:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/SellerLogin_in.html'
              break;
            case 1:
              this.view.src= this.interfaceJson.ipUrl+'/siteIn/in/in_p1.html'
              break;
            case 2:
              this.view.src= this.interfaceJson.ipUrl+'/siteIn/in/in_p2.html'
                break;
            case 3:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p3.html'
                break;
            case 4:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p4.html'
                break;
            case 5:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p5.html'
                break;
            case 6:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p6.html'
                break; 
            case 7:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p7.html'
                break; 
            case 8:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p8.html'
                break; 
            case 9:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p9.html'
                break; 
            case 10:
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p10.html'
              break;
            case 11:
              this.getManager(this.mPage)
              this.isScore=true;
              this.isSelectPop=false;
              break;                   
                
         }
      },
      goPinyin(){
        if(this.zwCont){
          this.pingyinCont= this.getPinyin(this.zwCont).trim()
        }
      },
      lePingyin(){
        this.isPingyin=!this.isPingyin;
      },
      deleteInfo(e){
          this.$axios
          .post(this.interfaceJson.serverAddress+"/api/site/amazonRegAccountInfoDelete",'IN')
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.reexamination=false
            this.AmazonRegAccountInfo={};
            this.infoScore=[];
            this.isScore=false;
            this.tips=false;
            sessionStorage.creditMarket = 0
            sessionStorage.removeItem('pageArr');
            // if(e!='ifemDe'){
             location.reload()
            // }
          }else{
            
          }
          });
      },
      calcs(arr){
       return arr.reduce((result, nextObj, i) => {
           return result + nextObj
       });
     },
      scoreFun(e){
      // 继续操作
        if(e=='1'){
           if(this.AmazonRegAccountInfo.step==10){
            this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p10.html'
          }else{
            this.goStep()
          }
          this.reexamination=false
        }
        if(e=='0'){
          if(this.user.zs==9){
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p1.html'
          }else{
            this.deleteInfo()
          }
        }
      },
      closeScore(){
        this.infoScore=[];
        this.isScore=false;
      },
      // 卖家1号评分数据
      getManager(mPage){
        this.infoScore=[];
        this.thisScore=0;
        this.numScore=0;
          // reg1
        if(mPage=='in_p1'||mPage=='in_p2'||mPage=='in_p3'||mPage=='in_p4'||mPage=='in_p5'||mPage=='in_p6'||mPage=='in_p7'||mPage=='in_p8'||mPage=='in_p9'||mPage=='in_p10'){
            this.thisScore= this.thisScore+(this.creditRuleEntityList[0].credit+this.creditRuleEntityList[1].credit+this.creditRuleEntityList[2].credit);
            this.numScore= this.numScore +(this.creditRuleEntityList[0].credit+this.creditRuleEntityList[1].credit+this.creditRuleEntityList[2].credit);
            this.infoScore.push({
                name:this.creditRuleEntityList[0].regInfo,
                mcont:'Kumar Deep',
                credit:this.creditRuleEntityList[0].credit,
                result:1,
                resultCont:this.creditRuleEntityList[0].correctShow,
                knowledgePoint:this.creditRuleEntityList[0].knowledgePoint
            },{
                name:this.creditRuleEntityList[1].regInfo,
                mcont:'996823010',
                credit:this.creditRuleEntityList[1].credit,
                result:1,
                resultCont:this.creditRuleEntityList[1].correctShow,
                knowledgePoint:this.creditRuleEntityList[1].knowledgePoint
            },{
                name:this.creditRuleEntityList[2].regInfo,
                mcont:'KumarDeep_185@hotmail.com',
                credit:this.creditRuleEntityList[2].credit,
                result:1,
                resultCont:this.creditRuleEntityList[2].correctShow,
                knowledgePoint:this.creditRuleEntityList[2].knowledgePoint
            })
        }
        // reg3
        if(mPage=='in_p4'||mPage=='in_p5'||mPage=='in_p6'||mPage=='in_p7'||mPage=='in_p8'||mPage=='in_p9'||mPage=='in_p10'){
            this.numScore= this.numScore +this.creditRuleEntityList[3].credit;
             this.thisScore=this.numScore;                           
            this.infoScore.push({
                name:this.creditRuleEntityList[3].regInfo,
                mcont:'Jhakaas Retail Private Limited',
                credit:this.creditRuleEntityList[3].credit,
                result:1,
                resultCont:this.creditRuleEntityList[3].correctShow,
                knowledgePoint:this.creditRuleEntityList[3].knowledgePoint
            })
        }
         // reg4
        if(mPage=='in_p5'||mPage=='in_p6'||mPage=='in_p7'||mPage=='in_p8'||mPage=='in_p9'||mPage=='in_p10'){
            this.thisScore= this.thisScore+(this.creditRuleEntityList[4].credit
            +this.creditRuleEntityList[5].credit
            +this.creditRuleEntityList[6].credit
            +this.creditRuleEntityList[7].credit
            +this.creditRuleEntityList[8].credit
            +this.creditRuleEntityList[9].credit
            +this.creditRuleEntityList[10].credit);
            this.numScore= this.thisScore;
            this.infoScore.push(
            {
                name:this.creditRuleEntityList[4].regInfo,
                mcont:'fsss',
                credit:this.creditRuleEntityList[4].credit,
                result:1,
                resultCont:this.creditRuleEntityList[4].correctShow,
                knowledgePoint:this.creditRuleEntityList[4].knowledgePoint
            },{
                name:this.creditRuleEntityList[5].regInfo,
                mcont:'400101',
                credit:this.creditRuleEntityList[5].credit,
                result:1,
                resultCont:this.creditRuleEntityList[5].correctShow,
                knowledgePoint:this.creditRuleEntityList[5].knowledgePoint
            },{
                name:this.creditRuleEntityList[6].regInfo,
                mcont:'CTS No. 658-A, 658-B, OFFICE NO 6, Gayatri Bhuvan',
                credit:this.creditRuleEntityList[6].credit,
                result:1,
                resultCont:this.creditRuleEntityList[6].correctShow,
                knowledgePoint:this.creditRuleEntityList[6].knowledgePoint
            },{
                name:this.creditRuleEntityList[7].regInfo,
                mcont: 'Complex 90 feetroad, Kandival',
                credit:this.creditRuleEntityList[7].credit,
                result:1,
                resultCont:this.creditRuleEntityList[7].correctShow,
                knowledgePoint:this.creditRuleEntityList[7].knowledgePoint
            },{
                name:this.creditRuleEntityList[8].regInfo,
                mcont: 'Mumbai',
                credit:this.creditRuleEntityList[8].credit,
                result:1,
                resultCont:this.creditRuleEntityList[8].correctShow,
                knowledgePoint:this.creditRuleEntityList[8].knowledgePoint
            },{
                name:this.creditRuleEntityList[9].regInfo,
                mcont: 'Maharashtra',
                credit:this.creditRuleEntityList[9].credit,
                result:1,
                resultCont:this.creditRuleEntityList[9].correctShow,
                knowledgePoint:this.creditRuleEntityList[9].knowledgePoint
            },{
                name:this.creditRuleEntityList[10].regInfo,
                mcont: 'Fulfillment by Amazon (FBA)',
                credit:this.creditRuleEntityList[10].credit,
                result:1,
                resultCont:this.creditRuleEntityList[10].correctShow,
                knowledgePoint:this.creditRuleEntityList[10].knowledgePoint
            })
        }
        // reg6
         if(mPage=='in_p7'||mPage=='in_p8'||mPage=='in_p9'||mPage=='in_p10'){
            this.thisScore= this.thisScore+this.creditRuleEntityList[11].credit;
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.creditRuleEntityList[11].regInfo,
                mcont: '981052891',
                credit:this.creditRuleEntityList[11].credit,
                result:1,
                resultCont:this.creditRuleEntityList[11].correctShow,
                knowledgePoint:this.creditRuleEntityList[11].knowledgePoint
            })
        }
         // reg8
         if(mPage=='in_p9'||mPage=='in_p10'){
            this.thisScore= this.thisScore+(this.creditRuleEntityList[12].credit+this.creditRuleEntityList[13].credit);
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.creditRuleEntityList[12].regInfo,
                mcont:'27AAECJ0000N1Z8',
                credit:this.creditRuleEntityList[12].credit,
                result:1,
                resultCont:this.creditRuleEntityList[12].correctShow,
                knowledgePoint:this.creditRuleEntityList[12].knowledgePoint
            },{
                name:this.creditRuleEntityList[13].regInfo,
                mcont:'AAECJ0000N',
                credit:this.creditRuleEntityList[13].credit,
                result:1,
                resultCont:this.creditRuleEntityList[13].correctShow,
                knowledgePoint:this.creditRuleEntityList[13].knowledgePoint
            })
        }
         // reg14
         if(mPage=='in_p10'){
            this.thisScore= this.thisScore+(this.creditRuleEntityList[14].credit
                                           +this.creditRuleEntityList[15].credit
                                           +this.creditRuleEntityList[16].credit
                                           +this.creditRuleEntityList[17].credit
                                           +this.creditRuleEntityList[18].credit
                                           +this.creditRuleEntityList[19].credit
                                           +this.creditRuleEntityList[20].credit
                                           +this.creditRuleEntityList[21].credit);
            this.numScore= this.thisScore
            this.infoScore.push({
                name:this.creditRuleEntityList[14].regInfo,
                mcont:'收取的运费',
                credit:this.creditRuleEntityList[14].credit,
                result:1,
                resultCont:this.creditRuleEntityList[14].correctShow,
                knowledgePoint:this.creditRuleEntityList[14].knowledgePoint
            },{
                name:this.creditRuleEntityList[15].regInfo,
                mcont:'Jhakaas Retail Private Limited',
                credit:this.creditRuleEntityList[15].credit,
                result:1,
                resultCont:this.creditRuleEntityList[15].correctShow,
                knowledgePoint:this.creditRuleEntityList[15].knowledgePoint
            },{
                name:this.creditRuleEntityList[16].regInfo,
                mcont:'储存账户',
                credit:this.creditRuleEntityList[16].credit,
                result:1,
                resultCont:this.creditRuleEntityList[16].correctShow,
                knowledgePoint:this.creditRuleEntityList[16].knowledgePoint
            },{
                name:this.creditRuleEntityList[17].regInfo,
                mcont:'FPAYAMZ1111',
                credit:this.creditRuleEntityList[17].credit,
                result:1,
                resultCont:this.creditRuleEntityList[17].correctShow,
                knowledgePoint:this.creditRuleEntityList[17].knowledgePoint
            },{
                name:this.creditRuleEntityList[18].regInfo,
                mcont:'FPAYAMZ1111',
                credit:this.creditRuleEntityList[18].credit,
                result:1,
                resultCont:this.creditRuleEntityList[18].correctShow,
                knowledgePoint:this.creditRuleEntityList[18].knowledgePoint
            },{
                name:this.creditRuleEntityList[19].regInfo,
                mcont:'CITI0101111',
                credit:this.creditRuleEntityList[19].credit,
                result:1,
                resultCont:this.creditRuleEntityList[19].correctShow,
                knowledgePoint:this.creditRuleEntityList[19].knowledgePoint
            },{
                name:this.creditRuleEntityList[20].regInfo,
                mcont: 'A_GEN_STANDARD (18%)',
                credit:this.creditRuleEntityList[20].credit,
                result:1,
                resultCont:this.creditRuleEntityList[20].correctShow,
                knowledgePoint:this.creditRuleEntityList[20].knowledgePoint
            },{
                name:this.creditRuleEntityList[21].regInfo,
                mcont: '已签名',
                credit:this.creditRuleEntityList[21].credit,
                result:1,
                resultCont:this.creditRuleEntityList[21].correctShow,
                knowledgePoint:this.creditRuleEntityList[21].knowledgePoint
            })
        }   
      },
      getBeforeAmazonRegAccountInfo(){
         this.$axios
        .get(this.interfaceJson.serverAddress+"/api/site/getBeforeAmazonRegAccountInfo?site=IN")
        .then(res => {
        let data=res.data;
        if(data.code==0){
            this.AmazonRegAccountInfo=data.data;
            if(!this.AmazonRegAccountInfo){
              this.reexamination=false;
              this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p1.html'
            }else{
              sessionStorage.m_loginData=JSON.stringify(data.data) 
              let arr=[]
              let reg0={}
              let reg1={}
              let reg2={}
              let reg3={}
              let reg4={}
              let reg5={}
              if(this.AmazonRegAccountInfo.step==10){
                this.reexamination=true;
                this.textCommonPop='已完成考核'
              }else if(this.AmazonRegAccountInfo.step>1){
                this.reexamination=true;
                this.textCommonPop='有未完成的考核'
              }
              if(this.AmazonRegAccountInfo.username){
                reg0.m_name=this.AmazonRegAccountInfo.username
              }
              if(this.AmazonRegAccountInfo.email){
                reg0.m_email=this.AmazonRegAccountInfo.email
              }
              if(this.AmazonRegAccountInfo.inAccount){
                 // 手机号
                  if(this.AmazonRegAccountInfo.inAccount.phone) {
                    reg0.m_phone=this.AmazonRegAccountInfo.inAccount.phone
                  }
                  // 两步验证手机号
                  if(this.AmazonRegAccountInfo.inAccount.svPhone) {
                    reg3.m_phone=this.AmazonRegAccountInfo.inAccount.svPhone
                  }
                  // GST号码
                  if(this.AmazonRegAccountInfo.inAccount.gstNumber) {
                    reg4.m_gstNumber=this.AmazonRegAccountInfo.inAccount.gstNumber
                  }
                  // PAN号码
                  if(this.AmazonRegAccountInfo.inAccount.panNumber) {
                    reg4.m_panNumber=this.AmazonRegAccountInfo.inAccount.panNumber
                  }
                   // 运费明细
                   if(this.AmazonRegAccountInfo.inAccount.postType) {
                    reg5.m_postType=this.AmazonRegAccountInfo.inAccount.postType
                  }
                   // 银行账户明细-持有人姓名
                   if(this.AmazonRegAccountInfo.inAccount.accountName) {
                    reg5.m_accountName=this.AmazonRegAccountInfo.inAccount.accountName
                  }
                   // 银行账户明细-账户类型
                   if(this.AmazonRegAccountInfo.inAccount.accountType) {
                    reg5.accountType=this.AmazonRegAccountInfo.inAccount.accountType
                  }
                  // 银行账户明细-账号
                   if(this.AmazonRegAccountInfo.inAccount.bankAccount) {
                    reg5.m_bankAccount=this.AmazonRegAccountInfo.inAccount.bankAccount
                  }
                  // 银行账户明细-重新输入账号
                   if(this.AmazonRegAccountInfo.inAccount.bankAccountRepeat) {
                    reg5.bankAccountRepeat=this.AmazonRegAccountInfo.inAccount.bankAccountRepeat
                  }
                  // 银行账户明细-IFSC代码
                   if(this.AmazonRegAccountInfo.inAccount.ifsc) {
                    reg5.m_ifsc=this.AmazonRegAccountInfo.inAccount.ifsc
                  }
                  // 默认产品税码
                   if(this.AmazonRegAccountInfo.inAccount.productTaxCode) {
                    reg5.productTaxCode=this.AmazonRegAccountInfo.inAccount.productTaxCode
                  }
                  // 签名
                   if(this.AmazonRegAccountInfo.inAccount.signature) {
                    reg5.signature=this.AmazonRegAccountInfo.inAccount.signature
                  }
              }
              if(this.AmazonRegAccountInfo.enterpriseStore){
                 // 法定名称
                  if(this.AmazonRegAccountInfo.enterpriseStore.businessName) {
                    reg1.m_legalname=this.AmazonRegAccountInfo.enterpriseStore.businessName
                  }
                  // 店铺名字
                  if(this.AmazonRegAccountInfo.enterpriseStore.storeName) {
                    reg2.storeName=this.AmazonRegAccountInfo.enterpriseStore.storeName
                  }
                  // 公司所在地邮编
                  if(this.AmazonRegAccountInfo.enterpriseStore.pincode) {
                    reg2.pincode=this.AmazonRegAccountInfo.enterpriseStore.pincode
                  }
                   // 公司地址栏1
                  if(this.AmazonRegAccountInfo.enterpriseStore.addressLine1) {
                    reg2.addressLine1=this.AmazonRegAccountInfo.enterpriseStore.addressLine1
                  }
                   // 公司地址栏2
                  if(this.AmazonRegAccountInfo.enterpriseStore.addressLine2) {
                    reg2.addressLine2=this.AmazonRegAccountInfo.enterpriseStore.addressLine2
                  }
                   // 公司所在城市
                  if(this.AmazonRegAccountInfo.enterpriseStore.city) {
                    reg2.city=this.AmazonRegAccountInfo.enterpriseStore.city
                  }
                   // 公司所在区域/州
                  if(this.AmazonRegAccountInfo.enterpriseStore.state!=null) {
                    reg2.state=this.AmazonRegAccountInfo.enterpriseStore.state
                  }
                   // 产品运送方式
                  if(this.AmazonRegAccountInfo.enterpriseStore.shipType) {
                    reg2.shipType=this.AmazonRegAccountInfo.enterpriseStore.shipType
                  }
                 
                 
              }
               
              if(JSON.stringify(reg0)!='{}'){
                arr.push(reg0)
              }
              if(JSON.stringify(reg1)!='{}'){
                arr.push(reg1)
              }
              if(JSON.stringify(reg2)!='{}'){
               
                arr.push(reg2)
              }
              if(JSON.stringify(reg3)!='{}'){
                arr.push(reg3)
              }
              if(JSON.stringify(reg4)!='{}'){
                arr.push(reg4)
              }
              if(JSON.stringify(reg5)!='{}'){
                arr.push(reg5)
              }
              sessionStorage.pageArr=JSON.stringify(arr)
            }
        }
        });
       
      },
      goStep(){
          this.view.src=this.interfaceJson.ipUrl+'/siteIn/in/in_p'+this.AmazonRegAccountInfo.step+'.html'
      },
      // getVirtualInfo(){
      //   this.$axios
      //     .get(this.interfaceJson.serverAddress+"/api/site/getVirtualInfo")
      //     .then(res => {
      //     let data=res.data;
      //     if(data.code==0){
      //       this.VirtualInfo=data.data
      //       sessionStorage.setItem('virtualInfo',JSON.stringify(data.data.accountInfo))
      //       sessionStorage.setItem('accountAddress',JSON.stringify(data.data.accountAddress))
      //       sessionStorage.setItem('businessInfoEntity',JSON.stringify(data.data.businessInfoEntity))
      //     }
      //   });
      // },
      getSite(){
          if(this.virtualConfigEntityList[0].helpBtn==0){
              this.isHelp=false;
            }else{
              this.isHelp=true;
            }
             if(this.virtualConfigEntityList[0].knowledgeBtn==0){
              this.isChis=false;
            }else{
              this.isChis=true;
            }
      },
     downloadCodeImg(e){
          var a = document.createElement('a')
         // 设置图片地址
          if(e==0){
            a.download =  '身份证正面';
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/身份证正面.jpg';
          }else if(e==1){
            a.download = '身份证背面';
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/身份证背面.jpg';
          }else{
            a.download = '营业执照正本'
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/营业执照正本.jpg';
          }
          a.click();
       },
      getScoreList(){
        let pageArr=null;
        if(sessionStorage.pageArr){
          pageArr= JSON.parse(sessionStorage.pageArr);
        }
        this.numScore=0;
        this.thisScore=0;
        this.infoScore=[];
        console.log(pageArr)
        if(pageArr){
         if(pageArr[0]){ 
              //  法人名字评分
          if(pageArr[0].m_name){
              this.numScore= this.numScore + this.creditRuleEntityList[0].credit;
            let reg_us={
                  name:this.creditRuleEntityList[0].regInfo,
                  mcont:pageArr[0].m_name,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.creditRuleEntityList[0].knowledgePoint
              }
              let isTrue=  this.youNameOK(pageArr[0].m_name)
              // console.log(isTrue)
            if(isTrue==10){
                this.thisScore= this.thisScore+this.creditRuleEntityList[0].credit
                reg_us.credit=this.creditRuleEntityList[0].credit
                reg_us.result=1
                reg_us.resultCont=this.creditRuleEntityList[0].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.creditRuleEntityList[0].errorShow
                this.infoScore.push(reg_us)
            }
          }
          //  邮箱评分
          if(pageArr[0].m_email){
              this.numScore= this.numScore+this.creditRuleEntityList[2].credit
              let reg_us={
                  name:this.creditRuleEntityList[2].regInfo,
                  mcont:pageArr[0].m_email,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.creditRuleEntityList[2].knowledgePoint
              }
            let isTrue=  this.emailOK(pageArr[0].m_email)
            if(isTrue==5){
                this.thisScore= this.thisScore+this.creditRuleEntityList[2].credit
                reg_us.credit=this.creditRuleEntityList[2].credit
                reg_us.result=1
                reg_us.resultCont=this.creditRuleEntityList[2].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.creditRuleEntityList[2].errorShow
                this.infoScore.push(reg_us)
            }
          }
          //  手机评分
          if(pageArr[0].m_phone){
              this.numScore= this.numScore+this.creditRuleEntityList[1].credit
              let reg_us={
                  name:this.creditRuleEntityList[1].regInfo,
                  mcont:pageArr[0].m_phone,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.creditRuleEntityList[1].knowledgePoint
              }
            let isTrue=  this.phoneOK(pageArr[0].m_phone)
            // console.log(isTrue)
            if(isTrue==8){
                this.thisScore= this.thisScore+this.creditRuleEntityList[1].credit
                reg_us.credit=this.creditRuleEntityList[1].credit
                reg_us.result=1
                reg_us.resultCont=this.creditRuleEntityList[1].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.creditRuleEntityList[1].errorShow
                this.infoScore.push(reg_us)
            }
          }
        }
        //  reg3
        if(pageArr[1]){
          //  法定名称
          if(pageArr[1].m_legalname){
              this.numScore= this.numScore+this.creditRuleEntityList[3].credit
              let reg_us={
                  name:this.creditRuleEntityList[3].regInfo,
                  mcont:pageArr[1].m_legalname,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.creditRuleEntityList[3].knowledgePoint
              }
            let isTrue =  this.businessNameOK(pageArr[1].m_legalname)
            if(isTrue==8){
              this.thisScore= this.thisScore+this.creditRuleEntityList[3].credit
                reg_us.credit=this.creditRuleEntityList[3].credit
                reg_us.resultCont=this.creditRuleEntityList[3].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.creditRuleEntityList[3].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
          }
        }
        //  reg4
        if(pageArr[2]){
          //店铺名字
          if(pageArr[2].storeName){
             this.numScore= this.numScore+this.creditRuleEntityList[4].credit
            let reg_us={
                name:this.creditRuleEntityList[4].regInfo,
                mcont:pageArr[2].storeName,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[4].knowledgePoint
            }
           let isTrue=  this.storeNameOK(pageArr[2].storeName)
           if(isTrue==3){
            this.thisScore =this.thisScore+this.creditRuleEntityList[4].credit
              reg_us.credit=this.creditRuleEntityList[4].credit
              reg_us.result=1
              reg_us.resultCont=this.creditRuleEntityList[4].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.creditRuleEntityList[4].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //公司所在地邮编
          if(pageArr[2].pincode){
            this.numScore= this.numScore+this.creditRuleEntityList[5].credit
            let reg_us={
                name:this.creditRuleEntityList[5].regInfo,
                mcont:pageArr[2].pincode,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[5].knowledgePoint
            }
           let isTrue=  this.pincodeOK(pageArr[2].pincode )
           if(isTrue==5){
              this.thisScore= this.thisScore+this.creditRuleEntityList[5].credit
              reg_us.credit=this.creditRuleEntityList[5].credit
              reg_us.resultCont=this.creditRuleEntityList[5].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.creditRuleEntityList[5].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          // 公司地址栏1
          if(pageArr[2].addressLine1){
            this.numScore= this.numScore+this.creditRuleEntityList[6].credit
            let reg_us={
                name:this.creditRuleEntityList[6].regInfo,
                mcont:pageArr[2].addressLine1,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[6].knowledgePoint
            }
           let isTrue=  this.addressOK(pageArr[2].addressLine1)//,this.VirtualInfo.businessInfoEntity.addressOne 
           if(isTrue){
              this.thisScore= this.thisScore+this.creditRuleEntityList[6].credit
              reg_us.credit=this.creditRuleEntityList[6].credit
              reg_us.result=1
              reg_us.resultCont=this.creditRuleEntityList[6].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.creditRuleEntityList[6].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //地址2
          if(pageArr[2].addressLine2){
             this.numScore= this.numScore+this.creditRuleEntityList[7].credit
            let reg_us={
                name:this.creditRuleEntityList[7].regInfo,
                mcont:pageArr[2].addressLine2,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[7].knowledgePoint
            }
           let isTrue=  this.addressOK(pageArr[2].addressLine2)
           if(isTrue==5){
             this.thisScore= this.thisScore+this.creditRuleEntityList[7].credit
              reg_us.credit=this.creditRuleEntityList[7].credit
              reg_us.resultCont=this.creditRuleEntityList[7].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.creditRuleEntityList[7].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //城市
          if(pageArr[2].city){
             this.numScore= this.numScore+this.creditRuleEntityList[8].credit
            let reg_us={
                name:this.creditRuleEntityList[8].regInfo,
                mcont:pageArr[2].city,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[8].knowledgePoint
            }
           let isTrue=  this.cityOK(pageArr[2].city)
           if(isTrue==3){
             this.thisScore= this.thisScore+this.creditRuleEntityList[8].credit
              reg_us.credit=this.creditRuleEntityList[8].credit
              reg_us.resultCont=this.creditRuleEntityList[8].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.creditRuleEntityList[8].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //所在省
          if(pageArr[2].state!=null){
             this.numScore= this.numScore+this.creditRuleEntityList[9].credit
            let reg_us={
                name:this.creditRuleEntityList[9].regInfo,
                mcont:this.StateArr[pageArr[2].state],
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[9].knowledgePoint
            }
           let isTrue=  this.stateOK(this.StateArr[pageArr[2].state])
           if(isTrue==3){
             this.thisScore= this.thisScore+this.creditRuleEntityList[9].credit
              reg_us.credit=this.creditRuleEntityList[9].credit
              reg_us.resultCont=this.creditRuleEntityList[9].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
               reg_us.resultCont=this.creditRuleEntityList[9].errorShow
              this.infoScore.push(reg_us)
           }
         }
         //产品运送方式
          if(pageArr[2].shipType){
            this.numScore= this.numScore+this.creditRuleEntityList[10].credit
            let reg_us={
                name:this.creditRuleEntityList[10].regInfo,
                mcont:pageArr[2].shipType=='1'?'Fulfillment by Amazon (FBA)':pageArr[2].shipType=='2'?'Easy Ship':'Self Ship',
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.creditRuleEntityList[10].knowledgePoint
            }
           let isTrue= this.shipping_methodOK(pageArr[2].shipType)
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[10].credit
              reg_us.credit=this.creditRuleEntityList[10].credit
              reg_us.result=1
              reg_us.resultCont=this.creditRuleEntityList[10].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.creditRuleEntityList[10].errorShow
              this.infoScore.push(reg_us)
           }
         }
        } 
        // reg7
        if(pageArr[3]){
         // 二步验证
          if(pageArr[3].m_phone){
              this.numScore= this.numScore+this.creditRuleEntityList[11].credit
              let reg_us={
                  name:this.creditRuleEntityList[11].regInfo,
                  mcont:pageArr[3].m_phone,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.creditRuleEntityList[11].knowledgePoint
              }
              let isTrue=  this.phone2SVOK(pageArr[3].m_phone)
            if(isTrue==8){
                this.thisScore= this.thisScore+this.creditRuleEntityList[11].credit
                reg_us.credit=this.creditRuleEntityList[11].credit
                reg_us.resultCont=this.creditRuleEntityList[11].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.creditRuleEntityList[11].errorShow
            }
          }
        }
        // reg8
        // GST号码
        if(pageArr[4]){
          // GST号码
          if(pageArr[4].m_gstNumber){
            this.numScore= this.numScore+this.creditRuleEntityList[12].credit
            let reg_us={
                name:this.creditRuleEntityList[12].regInfo,
                mcont:pageArr[4].m_gstNumber,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[12].knowledgePoint
            }
           let isTrue= this.GSTOK(pageArr[4].m_gstNumber)
           if(isTrue==5){
              this.thisScore= this.thisScore+this.creditRuleEntityList[12].credit
              reg_us.credit=this.creditRuleEntityList[12].credit
              reg_us.resultCont=this.creditRuleEntityList[12].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[12].errorShow
           }
          }
          //  PAN号码
          if(pageArr[4].m_panNumber){
              this.numScore= this.numScore+this.creditRuleEntityList[13].credit
              let reg_us={
                  name:this.creditRuleEntityList[13].regInfo,
                  mcont:pageArr[4].m_panNumber,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.creditRuleEntityList[13].knowledgePoint
              }
            let isTrue= this.PANOK(pageArr[4].m_panNumber)
            if(isTrue==5){
                this.thisScore= this.thisScore+this.creditRuleEntityList[13].credit
                reg_us.credit=this.creditRuleEntityList[13].credit
                reg_us.resultCont=this.creditRuleEntityList[13].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.creditRuleEntityList[13].errorShow
            }
          }
        }
          // reg9
        if(pageArr[5]){
            // 运费明细
          if(pageArr[5].m_postType){
            this.numScore= this.numScore+this.creditRuleEntityList[14].credit
            let reg_us={
                name:this.creditRuleEntityList[14].regInfo,
                mcont:pageArr[5].m_postType==0,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[14].knowledgePoint
            }
           let isTrue= this.feeOK(pageArr[5].m_postType) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[14].credit
              reg_us.credit=this.creditRuleEntityList[14].credit
              reg_us.resultCont=this.creditRuleEntityList[14].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[14].errorShow
           }
         }
         //  银行账户明细-持有人姓名
          if(pageArr[5].m_accountName){
            this.numScore= this.numScore+this.creditRuleEntityList[15].credit
            let reg_us={
                name:this.creditRuleEntityList[15].regInfo,
                mcont:pageArr[5].m_accountName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[15].knowledgePoint
            }
           let isTrue= this.holderNameOK(pageArr[5].m_accountName) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[15].credit
              reg_us.credit=this.creditRuleEntityList[15].credit
              reg_us.resultCont=this.creditRuleEntityList[15].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[15].errorShow
           }
         }
         //  银行账户明细-账户类型
          if(pageArr[5].accountType){
            this.numScore= this.numScore+this.creditRuleEntityList[16].credit
            let reg_us={
                name:this.creditRuleEntityList[16].regInfo,
                mcont:this.accountTypeArr[pageArr[5].accountType] ,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[16].knowledgePoint
            }
           let isTrue= this.accountTypeOK(pageArr[5].accountType) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[16].credit
              reg_us.credit=this.creditRuleEntityList[16].credit
              reg_us.resultCont=this.creditRuleEntityList[16].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[16].errorShow
           }
         }
         //  银行账户明细-账号
          if(pageArr[5].m_bankAccount){
            this.numScore= this.numScore+this.creditRuleEntityList[17].credit
            let reg_us={
                name:this.creditRuleEntityList[17].regInfo,
                mcont:pageArr[5].m_bankAccount,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[17].knowledgePoint
            }
           let isTrue= this.accountNumOK(pageArr[5].m_bankAccount) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[17].credit
              reg_us.credit=this.creditRuleEntityList[17].credit
              reg_us.resultCont=this.creditRuleEntityList[17].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[17].errorShow
           }
         }
         //  银行账户明细-重新输入账号
          if(pageArr[5].bankAccountRepeat){
            this.numScore= this.numScore+this.creditRuleEntityList[18].credit
            let reg_us={
                name:this.creditRuleEntityList[18].regInfo,
                mcont:pageArr[5].bankAccountRepeat,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[18].knowledgePoint
            }
           let isTrue= this.accountNumOK(pageArr[5].bankAccountRepeat) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[18].credit
              reg_us.credit=this.creditRuleEntityList[18].credit
              reg_us.resultCont=this.creditRuleEntityList[18].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[18].errorShow
           }
         }
         //  银行账户明细-IFSC代码
          if(pageArr[5].m_ifsc){
            this.numScore= this.numScore+this.creditRuleEntityList[19].credit
            let reg_us={
                name:this.creditRuleEntityList[19].regInfo,
                mcont:pageArr[5].m_ifsc,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[19].knowledgePoint
            }
           let isTrue= this.IFSCOK(pageArr[5].m_ifsc) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[19].credit
              reg_us.credit=this.creditRuleEntityList[19].credit
              reg_us.resultCont=this.creditRuleEntityList[19].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[19].errorShow
           }
         }
          //  默认产品税码
          if(pageArr[5].productTaxCode){
            this.numScore= this.numScore+this.creditRuleEntityList[20].credit
            let reg_us={
                name:this.creditRuleEntityList[20].regInfo,
                mcont:this.TaxCodeArr[pageArr[5].productTaxCode],
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[20].knowledgePoint
            }
           let isTrue= this.TaxCodeOK(pageArr[5].productTaxCode) 
           if(isTrue==3){
              this.thisScore= this.thisScore+this.creditRuleEntityList[20].credit
              reg_us.credit=this.creditRuleEntityList[20].credit
              reg_us.resultCont=this.creditRuleEntityList[20].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[20].errorShow
           }
         }
         //  签名
          if(pageArr[5].signature){
            this.numScore= this.numScore+this.creditRuleEntityList[21].credit
            let reg_us={
                name:this.creditRuleEntityList[21].regInfo,
                mcont:pageArr[5].signature=="0"?'已填写':'未填写',
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.creditRuleEntityList[21].knowledgePoint
            }
           if(pageArr[5].signature=="0"){
              this.thisScore= this.thisScore+this.creditRuleEntityList[21].credit
              reg_us.credit=this.creditRuleEntityList[21].credit
              reg_us.resultCont=this.creditRuleEntityList[21].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.creditRuleEntityList[21].errorShow
           }
         }
        }
        }

      }
      ,
     cancalChild(e) {
       if(e=='score'){
         if(this.infoScore){
           this.isScore=true;
           this.getScoreList()
           this.isSelectPop=false;
         }
       }
       if(e==0){
        this.AccountInfo=true;
        this.isIds=false;
         this.businessLicense=false;
       }else if(e==1){  
         this.isIds=true;
         this.AccountInfo=false;
          this.businessLicense=false;

       }else if(e==2){
         this.businessLicense=true;
         this.AccountInfo=false;
         this.isIds=false;
       }
       else if(e=='pingyin'){
         this.isPy=!this.isPy
         this.zwCont='';
         this.pingyinCont='';
       }
       else if(e=='leasing'){
         this.isLeasing=!this.isLeasing
       }
       else if(e=='chis'){
         if(this.chis=='0') {
              this.iframeWin.postMessage({
                chis:'1'
                }, '*') 
                this.chis='1'
                this.isChisShow=true;
         }else{
              this.iframeWin.postMessage({
              chis:'0'
              }, '*') 
              this.chis='0'
              this.isChisShow=false;
         } 
       }else if(e=='help'){
          if(this.help=='0') {
              this.iframeWin.postMessage({
                help:'1'
                }, '*') 
                this.help='1'
                this.isHelpShow=true;
         }else{
              this.iframeWin.postMessage({
              help:'0'
              }, '*') 
              this.help='0'
              this.isHelpShow=false;
         } 
       }
    },
  },
  components: {
    SiteHead,
    CommonPop
  }
};
</script>
<style lang="scss" scoped>

.colsPop{
  position: fixed;
  width:400px;
  height:625px;
  top:85px;
  z-index: 99999;
  background:#ffffff;
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 24px 0 25px;
  left: 24px;
}

.colsCont{
  position: relative;
  .pinyin{
    position: absolute;
    left: 0px;
    bottom: -25px;
    border:1px solid #F3CD70;
    font-size: 12px;
    height: 30px;
    border-radius: 21px;
    line-height: 30px;
    text-align: center;
    width: 90px;
    cursor: pointer;
  }
  .lv{
    background-color: #F3CD70;
  }
}
.colsCont .close{
  position: absolute;
  top: 16px;
  right: 0px;
  cursor: pointer;
  color: #232F3E;
}
.colsCont .close img{
  width: 16px;
  height: 16px;
}
.colsPop .head{
  border-bottom:1px solid #e8e8e8;
  height: 88px;
 
}
.colsPop .head .uname{
  font-size:18px;
  line-height: 25px;
  padding-top:15px;

}
.colsPop .head .de{
  padding-top:10px;
  font-size: 12px;
  color: #FF9A00;
  line-height: 15px;
}
.colsPop .cont{
  padding-bottom: 14px;
  border-bottom: 1px dashed #e8e8e8;
}
.colsPop .cont:last-of-type{
   border-bottom: 0;
}
.colsPop .cont .name{
  font-size:14px;
  line-height: 25px;
  padding-top:5px;
  padding-bottom: 10px;
  position: relative;
}
.colsPop .cont .dv{
  padding-bottom: 8px;
  display: flex;
}
.colsPop .cont .dName{
  display: flex;
  justify-content: space-between;
      width: 112px;
  span{
    font-size: 12px;
    color: #57616C;
  }
}
.colsPop .cont .dv .span{
  color: #000000;
  max-width: 240px;
  line-height: 18px;
  margin-top: -3px;
  word-wrap:break-word
}
.colsPop .cont .dv .ee{
  margin-left: 8px;
}
.colsPop .cont img{
  width:352px;
}
.colsPop .cont .btn{
  width:80px;
  height:30px;
  font-size:12px;
  background:#F3CD70;
  opacity:1;
  border-radius:21px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 4px;
  right: 183px;
}
.pyPop{
   height: 188px;
   left: auto;
   right: 0px;
   .close{
     top: 11px;
   }
   .head{
     height: 40px !important;
     line-height: 40px;
     .uname{
        padding-top: 0;
        font-size: 14px;
        line-height: 40px !important;
     }
   }
   .input_wrap{
     padding-top: 21px;
     .ipt{
       padding-bottom: 10px;
       display: flex;
       label{
         font-size:14px;
         margin-left: 5px;
         width: 42px;
        height:30px;
        line-height: 30px;
       }
       input{
         width:283px;
          height:30px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(232,232,232,1);
          opacity:1;
          border-radius:4px;
          outline: none;
          box-sizing: border-box;
          padding-left: 10px;
       }
     }
   }
   .iBtn{
      width:68px;
      height:20px;
      background:rgba(243,205,112,1);
      opacity:1;
      border-radius:4px;
      text-align: center;
      position: absolute;
      font-size: 12px;
      line-height: 20px;
      right: 0px;
      bottom: -37px;
      cursor: pointer;
   }
}
.view{
  height:calc(100vh - 80px) ;
  margin: 0 auto;
}
.view  iframe{
  height:100%;
  width: 100%;
}
.Home{
  background-color: #FFFFFF;
}
.content{
  // max-width: 1380px;
  // padding-top:10px ;
  margin: 0 auto;
  box-sizing: border-box;
}
.siteWrap {
  display: flex;
}
.siteWrap .siteUl{
  display: flex;
  flex-wrap:wrap ;
}
.siteWrap .siteUl .siteLi{
  margin-right: 20px;
  margin-bottom: 20px;
}
.siteWrap .siteUl .siteLi:nth-child(5n-0){
  margin-right: 0px;
}
.siteWrap .siteUl .siteLi .icon{
  background-color: #232F3E;
  height: 128px;
}
.siteWrap .siteUl .siteLi .icon img{
  width: 96px;
  height: 96px;
  padding: 26px 82px 0 82px;
}
.siteWrap .siteUl .siteLi .name{
  color: #FFFFFF;
  background-color: #2F3A48;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
// 评分弹窗
.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #000;
    opacity: .5;
}
.scorePop{
  	position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999;
    background-color: #fff;
    transform: translate(-50%, -50%);
    width: 1180px;
    height:500px;
    box-sizing: border-box;
    padding:0 23px 0 23px;
    .head{
      height: 85px;
      display: flex;
      position: relative;
      .el{
        display: flex;
        padding-top: 19px;
        .li{
          width: 77px;
          height: 77px;
          border:1px solid #D6D6D6;
          background-color: #fff;
          border-radius:50%;
          box-sizing: border-box;
          .num{
            width:40px;
            height:30px;
            font-size:22px;
            font-family:PingFang SC;
            font-weight:bold;
            line-height:30px;
            color: #000000;
            text-align: center;
            margin: 12px auto 0;
            border-bottom: 1px solid #D6D6D6;
          }
          .nx{
            font-size:12px;
            line-height:17px;
            color: #232F3E;
            text-align: center;
            line-height: 17px;
            margin-top: 6px;
          }
        }
        .avt{
          margin-right: 17px;
          background-color: #F3CD70;
          border:1px solid #F3CD70;
          .num{
            border-bottom: 1px solid #000000;
          }
        }
      }
      .ps{
        width:444px;
        height:17px;
        font-size:12px;
        font-weight:400;
        line-height:17px;
        color:#FF0000;
        margin-left: 17px;
        margin-top: 68px;
      }
      .btnScore{
          position: absolute;
          right: 24px;
          top:46px;
          width:110px;
          height:32px;
          background:#F3CD70;
          line-height: 32px;
          border-radius:4px;
          color: #232F3E;
          font-size:14px;
          text-align: center;
          cursor: pointer;
      }
      .close{
        position: absolute;
        top: 10px;
        right:5px;
        cursor: pointer;
        img{
          width: 16px;
          height: 16px;
        }
      }
    }
    .cont{
      margin-top: 10px;
      max-height: 358px;
      overflow-y: scroll;
      .titUl{
        display: flex;
        .li{
            flex: 1;
            border:1px solid #E1E1E2;
            padding-left: 12px;
            height: 50px;
            line-height: 15px;
            align-items: center;
            color: #000000;
            display: flex;
            font-size:14px;
            background-color: #EBEBEB;
            border-right:0;
        }
        .li:last-of-type{
          border-right:1px solid #E1E1E2;
        }
        .fx4{
            flex: 4; 
        }
      }
      .conList{

        .titUl{
          .li{
            font-size: 12px;
            background-color: #F5F5F5;
            display: flex;
            align-items: center;
          }
          .dP{
           
            img{
              width:20px;
              margin-right: 10px;
            }
          }  
        }
        .titUl:nth-child(odd){
           .li{
              border-top: 0;
             border-bottom: 0;
             background-color: #fff;
           }

        }
        .titUl:last-of-type{
           border-bottom:1px solid #E1E1E2;
            .li{
              border-bottom: 0;
            }
        }
        .avt{
            .li{
              color: #FF0000;
           }
        } 
      }
      
    }
}
.selectPop{
  position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  width:400px;
  height:200px;
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 25px;
  .title{
    border-bottom:1px solid #e8e8e8;
    height: 81px;
    line-height: 81px;
    font-size:18px;
    color: #000;
    text-align: center;
    position: relative;
    .close{
      position: absolute;
      top: -13px;
      right: 0px;
      cursor: pointer;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
  .btn{
    width:120px;
    height:40px;
     text-align: center;
    background:rgba(243,205,112,1);
    opacity:1;
    border-radius:21px;
    font-size:14px;
    color:rgba(35,47,62,1);
    line-height: 40px;
    margin: 47px auto 0;
    cursor: pointer;
  }
}
.tipsPop{
	width: 400px;
	height: 235px;
	box-shadow:0px 0px 20px rgba(0,0,0,0.16);
	border-radius:2px;
	position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 0  32px 0 34px;
  .head{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-bottom:1px solid #E8E8E8;
    color: #000000;
    position: relative;
     .icon{
        position: absolute;
        right: -10px;
        top: 0px;
        cursor: pointer;
        img{
          width: 10px;
          height: 10px;
        }
      } 
  }
  .co{
    width:322px;
    line-height:20px;
    font-size:12px;
    margin-top: 12px;
    text-align: center;
  }
  .cont{
    text-align: center;
    line-height:20px;
    font-size:12px;
    margin: 0 auto;
    width:300px;
    padding-top: 25px;
  }
  .btnWrap{
    text-align: center;
    margin-top:34px;
    .btn{
      width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #F3CD70;
      color: #232F3E;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .btnN{
       width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #FFFFFF;
      border:1px solid rgba(243,205,112,1);
      box-sizing: border-box;
      color: #57616C;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
}
</style>
<style >
  .Home .el-carousel__container  {
    height: 580px;
  }
</style>